import { useMobilePanel } from '@/components/layout/Navigation/mobile';
import { NavItem } from '@/components/layout/Navigation/sidebar';
import { useIsRibbonSidebarEnabled } from '@/features/flags';
import { trackTemplateLibraryViewed } from '@/lib/analytics/scribe/template';
import { SidebarMenu } from '@heidi/design-system/page-shell';
import { useTranslations } from '@heidi/runtime/i18n';
import { Globe } from 'lucide-react';

export interface TemplateGroupNavItemsProps {
  startTransition: (fn: () => void) => void;
  closeSidePanels: () => void;
  shouldHighlightCommunity: boolean;
  onNextPage: () => void;
  isTemplatesActive: boolean;
}

export function TemplateGroupNavItems({
  startTransition,
  closeSidePanels,
  shouldHighlightCommunity,
  onNextPage,
  isTemplatesActive,
}: TemplateGroupNavItemsProps) {
  const { t } = useTranslations();
  const { dismissMobileSidebar } = useMobilePanel();
  const isRibbonSidebarEnabled = useIsRibbonSidebarEnabled();

  return (
    <SidebarMenu>
      {!isRibbonSidebarEnabled && (
        <NavItem
          label={t('sidenav.templates')}
          icon={<Globe />}
          href="/templates"
          isActive={isTemplatesActive}
          onClick={() => {
            startTransition(() => {
              trackTemplateLibraryViewed();
              closeSidePanels();
              if (shouldHighlightCommunity) {
                onNextPage();
              }
            });
            dismissMobileSidebar();
          }}
          testId="sidebar-link-templates"
        />
      )}
    </SidebarMenu>
  );
}
